document.addEventListener('DOMContentLoaded', () => {
  // Quantity decrease
  document.querySelectorAll('.quantity__button[name="minus"]').forEach(button => {
    button.addEventListener('click', () => {
      const input = button.closest('.quantity').querySelector('.quantity__input');
      const currentQty = parseInt(input.value);
      const variantId = input.dataset.quantityVariantId;
      if (!variantId || isNaN(currentQty)) return;
      const newQty = currentQty - 1;
      if (newQty > 0) {
        input.value = newQty;
        updateCart(variantId, newQty);
      } else if (newQty === 0) {
        updateCart(variantId, 0);
      }
    });
  });

  // Quantity increase
  document.querySelectorAll('.quantity__button[name="plus"]').forEach(button => {
    button.addEventListener('click', () => {
      const input = button.closest('.quantity').querySelector('.quantity__input');
      const currentQty = parseInt(input.value);
      const variantId = input.dataset.quantityVariantId;
      if (!variantId || isNaN(currentQty)) return;
      const newQty = currentQty + 1;
      input.value = newQty;
      updateCart(variantId, newQty);
    });
  });

  // Add to cart from blog sidebar - FINAL IMPROVED VERSION
  document.querySelectorAll('.sidebar-add-to-cart').forEach(button => {
    button.addEventListener('click', async () => {
      const variantId = button.getAttribute('data-variant-id');
      if (!variantId) return;

      button.disabled = true;
      const originalText = button.textContent;
      button.textContent = 'Adding...';

      try {
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (!res.ok) throw new Error(`Add to cart failed: ${res.status}`);

        // Get the cart response to verify the item was added
        const cartData = await res.json();
        console.log('Item added to cart:', cartData);

        // Wait for Shopify to fully process the cart update
        await new Promise(resolve => setTimeout(resolve, 300));

        // Fetch updated cart sections with retry logic
        await updateCartSections(variantId);

      } catch (err) {
        console.error('Cart add error:', err);
        alert('Error adding product to cart. Please try again.');
      } finally {
        button.disabled = false;
        button.textContent = originalText;
      }
    });
  });

  // Improved function to update cart sections with retry logic
  async function updateCartSections(variantId, retryCount = 0) {
    const maxRetries = 3;
    
    try {
      // First verify that the cart actually contains items
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      console.log(`Cart check (attempt ${retryCount + 1}): ${cart.item_count} items`);
      
      // If cart is empty and we haven't exceeded retry limit, try again
      if (cart.item_count === 0 && retryCount < maxRetries) {
        console.log(`Cart still empty, retrying in 400ms... (${retryCount + 1}/${maxRetries})`);
        await new Promise(resolve => setTimeout(resolve, 400));
        return updateCartSections(variantId, retryCount + 1);
      }
      
      // If still empty after all retries, show error but continue
      if (cart.item_count === 0) {
        console.warn('Cart appears empty after all retries, but continuing with section update...');
      }

      const sectionsToUpdate = ['cart-drawer', 'cart-icon-bubble'];
      const sectionsUrl = `${window.Shopify?.routes?.root || ''}cart?sections=${sectionsToUpdate.join(',')}`;
      
      const sectionsRes = await fetch(sectionsUrl);
      
      if (!sectionsRes.ok) throw new Error(`Section fetch failed: ${sectionsRes.status}`);

      const sections = await sectionsRes.json();
      const parsedState = { sections, id: variantId };

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(parsedState);
        
        // Small delay before opening to ensure rendering is complete
        setTimeout(() => {
          cartDrawer.open();
        }, 150);
      } else {
        console.log('Cart drawer not found, redirecting to cart page');
        window.location.href = '/cart';
      }
      
    } catch (error) {
      console.error('Error updating cart sections:', error);
      if (retryCount < maxRetries) {
        console.log(`Retrying due to error... (${retryCount + 1}/${maxRetries})`);
        await new Promise(resolve => setTimeout(resolve, 500));
        return updateCartSections(variantId, retryCount + 1);
      } else {
        console.error('All retries failed, redirecting to cart page');
        window.location.href = '/cart';
      }
    }
  }

  // Improved updateCart function with better error handling and retry logic
  async function updateCart(variantId, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity })
      });

      if (!res.ok) throw new Error(`Cart update failed: ${res.status}`);
      
      const cartData = await res.json();
      console.log('Cart updated:', cartData);
      
      // Wait for cart update to be processed
      await new Promise(resolve => setTimeout(resolve, 300));
      
      // Update cart sections with retry logic
      await updateCartSectionsForQuantityChange();
      
    } catch (err) {
      console.error('Cart update error:', err);
      location.reload();
    }
  }

  // Separate function for quantity change updates (doesn't need to open drawer)
  async function updateCartSectionsForQuantityChange(retryCount = 0) {
    const maxRetries = 2;
    
    try {
      const sectionsToUpdate = ['cart-drawer', 'cart-icon-bubble'];
      const sectionsUrl = `${window.Shopify?.routes?.root || ''}cart?sections=${sectionsToUpdate.join(',')}`;
      
      const res = await fetch(sectionsUrl);
      
      if (!res.ok) throw new Error(`Section fetch failed: ${res.status}`);
      
      const sections = await res.json();
      const parsedState = { sections };
      
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(parsedState);
      } else {
        location.reload();
      }
      
    } catch (error) {
      console.error('Error updating cart sections for quantity change:', error);
      if (retryCount < maxRetries) {
        await new Promise(resolve => setTimeout(resolve, 300));
        return updateCartSectionsForQuantityChange(retryCount + 1);
      } else {
        location.reload();
      }
    }
  }
});